(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('UserDashboardController', UserDashboardController);

    /* @ngInject */
    function UserDashboardController($q,
        logger,
        userService,
        userOnBoardingService,
        pendingUserService,
        $uibModal, $state) {

        //Private Variables
        var vm = this;
        var userModalOptions = userService.getModalOptions();
        var onBoardOptions = userOnBoardingService.getModalOptions();

        //Public Variables
        vm.users = [];
        vm.isFilterCollapsed = true;
        vm.title = 'User Dashboard';
        vm.loadingMessage = 'Loading ... ';
        vm.ConnectionTypes = userService.getConnectionTypes();

        //Public Methods
        vm.getUsers = userService.getUsers;
        vm.editUser = editUser;
        vm.setActive = setActive;

        vm.onBoardUser = onBoardUser;
        vm.updateUserCustomer = updateUserCustomer;

        // Smart Table
        vm.tableConfig = configureTableActions();

        // DI / IOC / unit testing / mocking
        vm.userService = userService;

        //Activate Controller
        activate();

        function activate() {
            logger.info('Activated User Dashboard View');
        }

        function onBoardUser() {
            $state.go('user.onboard');
        }

        function updateUserCustomer() {
            vm.request = {
            };

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/user/dashboard/modal/update.user.customer.modal.html',
                controller: 'UpdateUserCustomerController',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return vm.request;
                    }
                }
            });

            modalInstance.result.then(function () {
                //alert("now I'll close the modal");
                console.log(vm.request);
            });
        }

        function editUser(user) {
            $state.go('user.edit', { userId: user.UserId });
        }

        function setActive(user) {
            user.IsActive = !user.IsActive;
            return userService.setActive(user)
                .then(function (result) {
                    if (result.status === 200) {
                        user = result.data;
                        logger.info('User ' + (user.IsActive ? 'Activated' : 'Deactivated'), result);
                    } else {
                        logger.error('Error Updating IsActive Flag', result);
                    }
                });
        }

        function hideResetPasswordForADUser(user) {
            return user.ConnectionTypeId === 2;
        }

        function resetUserPassword(user) {
            return userService.resetUserPassword(user)
                .then(function (result) {
                    if (result.status === 200) {
                        user = result.data;
                        logger.info('User password reset email sent', result);
                    } else {
                        logger.error('Error sending reset password email', result);
                    }
                });
        }

        function configureTableActions() {
            var tableConfig = userService.getTableConfig();
            tableConfig.actions = [
                {
                     name: '"Edit"',
                     action: editUser,
                     icon: '"fa-pencil"',
                     permission: ['SSO:SysAdmin', 'SSO:AppAdmin', 'SSO:Create_User',
                         'SSO:Corp:Admin', 'SSO:Reg:Admin', 'SSO:Area:Admin', 'SSO:Site:Admin']
                 },
                {
                    name: 'row.IsActive ? "Block" : "Unblock"',
                    action: setActive,
                    icon: 'row.IsActive ? "fa-check-circle" : "fa-times-circle"',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin', 'SSO:Create_User',
                        'SSO:Corp:Admin', 'SSO:Reg:Admin', 'SSO:Area:Admin', 'SSO:Site:Admin']
                },
                {
                    name: '"Reset Password"',
                    action: resetUserPassword,
                    icon: '"fa-unlock-alt"',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin', 'SSO:Create_User',
                        'SSO:Corp:Admin', 'SSO:Reg:Admin', 'SSO:Area:Admin', 'SSO:Site:Admin'],
                    filterDropDown: hideResetPasswordForADUser
                }
            ];
            return tableConfig;
        }
    }
})();
